import { useCallback, useEffect, useRef, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { api } from "../../../../services/api";
import Loading from "../../../../components/Loading";
import "./eventopublic.css";
import HeaderPublic from "./HeaderPublic";
import DrawerPublic from "./drawer/first-drawer/FirstDrawerMobile";
import PrivateEvent from "../../../../components/ProtectedRoutes/PrivateEvent";
import { useMediaQuery } from "react-responsive";
import { ContentDesktop } from "./contenido/desktop/ContentDesktop";
import ContentMobile from "./contenido/mobile/ContentMobile";
import FirstDrawerDesktop from "./drawer/first-drawer/FirstDrawerDesktop";
import { Box, Paper, Typography } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import PublicDisponibilidadModal from "../../../../components/modales/ubicaciones/PublicDisponibilidadModal";
import { capturar } from "../../../../domain/atribucion/atribucion";
import { configurarEvento, rastrear } from "../../../../domain/metaPixel/metaPixel";
import { EVENTO_CAMBIO } from "../../../../domain/consentimiento/consentimiento";
import { useBarraInferior } from "../../../../hooks/useBarraInferior";
import { MapaCompraContext, useMapaPublico } from "../../../../components/compra/MapaCompra";

export const EventoPublic = () => {
	const history = useHistory();
	const location = useLocation();
	const [data, setData] = useState();
	const [isPrivated, setIsPrivated] = useState();
	const [asientosSeleccionados, setAsientosSeleccionados] = useState({});
	const param = useParams();
	const eventoId = param.id;
	const [cantidad, setCantidad] = useState({});
	const [showResume, setShowResume] = useState(false);
	const [openDrawer, setOpenDrawer] = useState(false);
	const [tarifasSeleccionadas, setTarifasSeleccionadas] = useState([]);
	const [mpVinculado, setMpVinculado] = useState();
	const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
	const mapaCompra = useMapaPublico(data?.id);

	const callApi = useCallback(async () => {
		try {
			const response = await api.eventos.getPublic(eventoId);
			if (response.status === "success") {
				setData(response.data.evento_public);
				setIsPrivated(response.data.evento_public.privado);

				const isSlugRoute = location.pathname.startsWith('/e/');
				const seccion = isSlugRoute ?
					location.pathname.split('/')[2] :
					`evento-${eventoId}`;

				if (window.gtag) {
					window.gtag('event', 'Eventos', {
						seccion: seccion,
						timestamp: new Date().toISOString()
					});
				}
			} else {
				history.push('/');
				return;
			}


		} catch (error) {
			console.error = () => { };
			history.push('/');
		}
	}, [eventoId, location.pathname]);

	// link de un canal o de un anuncio: se guarda para atribuir la compra
	useEffect(() => {
		try {
			const ref = capturar(eventoId, location.search);
			if (ref) api.canales.visita(eventoId, ref).catch(() => { });
		} catch {
			// sin acceso al almacenamiento del navegador la compra sigue sin atribución
		}
	}, [eventoId, location.search]);

	// pixel de Meta del organizador: se carga sólo si el visitante acepta publicidad
	const [seguimiento, setSeguimiento] = useState(null);
	const vistaInformada = useRef(false);
	useEffect(() => {
		vistaInformada.current = false;
		api.seguimiento.publico(eventoId)
			.then((r) => {
				configurarEvento(eventoId, r?.data);
				setSeguimiento(r?.data || null);
			})
			.catch(() => { });
	}, [eventoId]);
	useEffect(() => {
		const pixel = seguimiento?.meta_pixel_id;
		if (!pixel || !data) return undefined;
		const informarVista = () => {
			if (vistaInformada.current || !rastrear(pixel, "PageView")) return;
			rastrear(pixel, "ViewContent", { content_ids: [String(data.id)], content_name: data.evento, content_type: "product" });
			vistaInformada.current = true;
		};
		informarVista();
		window.addEventListener(EVENTO_CAMBIO, informarVista);
		return () => window.removeEventListener(EVENTO_CAMBIO, informarVista);
	}, [seguimiento, data]);

	useEffect(() => {
		callApi()
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [callApi, history]);

	const tarifasTicketsFiltrados = data?.tarifas?.filter((tarifa) => {
		const tarifasMenoresOcultas = [702, 703, 704];
		// los adicionales de una mesa entera sólo se suman desde la mesa
		const adicionalDeMesa = mapaCompra.indice?.adicionales.has(tarifa.id);
		return tarifa.idtipo === 1 && !tarifasMenoresOcultas.includes(tarifa.id) && !adicionalDeMesa;
	});

	const tarifasVouchersFiltrados = data?.tarifas?.filter((tarifa) => tarifa.idtipo === 2);

	const toggleDrawer = (newOpenDrawer) => () => {
		setOpenDrawer(newOpenDrawer);
		setShowResume(false);
	};

	const [openMapaModal, setOpenMapaModal] = useState(false);
	const refBarraMapa = useBarraInferior();

	// si o si visionario
	const esEventoVisionario = data?.id === 461;

	const zonaVisionario = {
		id: 468,
		ubicacion: "Vizenzo"
	};

	const abrirMapa = () => {
		setOpenMapaModal(true);
	};

	if (!data || !mapaCompra.cargado) {
		return <Loading />;
	}

	return (
		<MapaCompraContext.Provider value={mapaCompra}>
			{isPrivated ? (
				<PrivateEvent />
			) : (
				<div style={{
					// vista pública full-width: el drawer es overlay y no reserva espacio
					marginLeft: 0,
					transition: "margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
				}}>
					<HeaderPublic data={data} />

					{isMobile ?
						<ContentMobile data={data} />
						:
						<ContentDesktop
							data={data}
							cantidad={cantidad}
							toggleDrawer={toggleDrawer}
							setCantidad={setCantidad}
							asientosSeleccionados={asientosSeleccionados}
							setAsientosSeleccionados={setAsientosSeleccionados}
							tarifasTicketsFiltrados={tarifasTicketsFiltrados}
							tarifasVouchersFiltrados={tarifasVouchersFiltrados}
							setTarifasSeleccionadas={setTarifasSeleccionadas} />
					}

					{esEventoVisionario && isMobile && (
						<>
							<Paper ref={refBarraMapa} elevation={8} sx={{
								position: 'fixed',
								bottom: 0,
								left: 0,
								right: 0,
								zIndex: 1300,
								background: 'white',
								padding: '12px 16px',
								borderRadius: '20px 20px 0 0',
								boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
								cursor: 'pointer',
								transition: 'all 0.3s ease',
								'&:hover': {
									transform: 'translateY(-2px)',
									boxShadow: '0 -6px 25px rgba(0, 0, 0, 0.2)',
								}
							}}
								onClick={abrirMapa}
							>
								<Box sx={{
									p: 2,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									borderRadius: '10px',
									gap: 2,
									color: 'white',
									backgroundColor: "#5656ff",
								}}>

									<Visibility sx={{ fontSize: 28 }} />

									<Box sx={{ textAlign: 'center' }}>
										<Typography variant="h6" sx={{
											fontWeight: 700,
											fontSize: '18px',
										}}>
											Ver mapa del evento
										</Typography>
									</Box>
								</Box>
							</Paper>

						</>
					)}
					<PublicDisponibilidadModal
						open={openMapaModal}
						onClose={() => setOpenMapaModal(false)}
						zona={zonaVisionario}
					/>
					{(tarifasTicketsFiltrados?.length > 0 || tarifasVouchersFiltrados?.length > 0) && (
						<>
							{isMobile ?
								<DrawerPublic
									data={data}
									cantidad={cantidad}
									toggleDrawer={toggleDrawer}
									openDrawer={openDrawer}
									setCantidad={setCantidad}
									asientosSeleccionados={asientosSeleccionados}
									setAsientosSeleccionados={setAsientosSeleccionados}
									mpVinculado={mpVinculado}
									tarifasTicketsFiltrados={tarifasTicketsFiltrados}
									tarifasVouchersFiltrados={tarifasVouchersFiltrados}
									tarifasSeleccionadas={tarifasSeleccionadas}
									setTarifasSeleccionadas={setTarifasSeleccionadas}
								/>
								:
								<FirstDrawerDesktop
									data={data}
									cantidad={cantidad}
									toggleDrawer={toggleDrawer}
									openDrawer={openDrawer}
									setCantidad={setCantidad}
									asientosSeleccionados={asientosSeleccionados}
									setAsientosSeleccionados={setAsientosSeleccionados}
									mpVinculado={mpVinculado}
									tarifasTicketsFiltrados={tarifasTicketsFiltrados}
									tarifasVouchersFiltrados={tarifasVouchersFiltrados}
									tarifasSeleccionadas={tarifasSeleccionadas}
									setTarifasSeleccionadas={setTarifasSeleccionadas} />
							}
						</>
					)}
				</div>
			)}
		</MapaCompraContext.Provider>
	);

};
